export const fetchWeather = async (lat, long) => {
  try {
    if (!window) {
      // we only ever expect to run this client side
      return null;
    }
    let hostname = window.location.hostname;
    if (window.location.port !== '') {
      hostname = `${hostname}:${window.location.port}`;
    }
    const metWeatherUri = `${window.location.protocol}//${hostname}/api/weather/metweather/${lat}/${long}`;
    const metWeather = await fetch(metWeatherUri);
    const weatherData = await metWeather.json();

    let updateTime = weatherData.weather.updateTime;
    const alertUrl = `https://api.weather.gov/alerts/active?point=${lat},${long}`;
    const alertRes = await fetch(alertUrl);
    const alertData = await alertRes.json();

    let data = {
      weather: {
        updateTime,
        temperature:
          weatherData.forecast[0].data.instant.details.air_temperature,
        precipitation:
          weatherData.forecast[0].data.next_1_hours.details
            .precipitation_amount,
        pressure:
          weatherData.forecast[0].data.instant.details
            .air_pressure_at_sea_level,
        dewpoint:
          weatherData.forecast[0].data.instant.details.dew_point_temperature,
        relativeHumidity:
          weatherData.forecast[0].data.instant.details.relative_humidity,
        symbolCode:
          weatherData.forecast[0].data.next_1_hours.summary.symbol_code,
      },
      forecast: weatherData.forecast,
      alerts: alertData.features,
    };

    return data;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
  }
};
